import {
	registerDecorator,
	ValidationArguments,
	ValidationOptions,
	ValidatorConstraint,
	ValidatorConstraintInterface
} from "class-validator";
import { FileUploadDto, parseBase64String } from "../../../shared/src";
import { isArray } from 'lodash-es';

@ValidatorConstraint({ name: 'Base64AllowedMimeTypes', async: true })
export class Base64AllowedMimeTypesValidator implements ValidatorConstraintInterface {
	async validate(value: FileUploadDto | FileUploadDto[], validationArguments: ValidationArguments) {
		try {
			if (!value) return true;

			const filesToValidate = isArray(value)
				? value as FileUploadDto[]
				: [value as FileUploadDto];

			for (const fileToValidate of filesToValidate) {
				if (!fileToValidate.base64EncodedFile) return true;

				const { mimeType } = parseBase64String(fileToValidate.base64EncodedFile);

				console.debug('mimeType', mimeType);
				if (!mimeType) return false;

				const { constraints: [allowedMimeTypes] } = validationArguments;

				if (!allowedMimeTypes?.length) {
					return true;
				}

				console.debug('allowedMimeTypes', allowedMimeTypes);
				const doesAllowedTypesIncludeCurrent = allowedMimeTypes.includes(mimeType);
				console.debug('doesAllowedTypesIncludeCurrent', doesAllowedTypesIncludeCurrent);

				if (!doesAllowedTypesIncludeCurrent) {
					return false;
				}
			}
		} catch (e) {
			return false;
		}

		return true;
	}

	defaultMessage(validationArguments: ValidationArguments) {
		const { constraints: [allowedMimeTypes] } = validationArguments;

		return `Mime type doesn't allowed. Allowed types are: ${allowedMimeTypes ? allowedMimeTypes.join(', ') : '*'}`;
	}
}

export const Base64AllowedMimeTypes = (allowedMimeTypes: string[], validationOptions?: ValidationOptions) => (object: Record<never, never>, propertyName: string): void => {
	registerDecorator({
		name: 'Base64AllowedMimeTypes',
		target: object.constructor,
		propertyName,
		options: validationOptions,
		validator: Base64AllowedMimeTypesValidator,
		constraints: [allowedMimeTypes],
	});
};
